/* eslint-disable */
import * as React from 'react';
const Reports_Icons = (props) => (
  <svg
    fill="#fff"
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 36 36"
    {...props}
  >
    <rect width={5.76} height={11.52} x={6.48} y={18} rx={1} ry={1} />
    <rect width={5.76} height={23.04} x={15.12} y={6.48} rx={1} ry={1} />
    <rect width={5.76} height={15.36} x={23.76} y={14.16} rx={1} ry={1} />
  </svg>
);
export default Reports_Icons;
